window.TS.initDatepicker = function(selector) {
  if (typeof selector === 'undefined') {
    selector = '.date-picker';
  }
  if ($(selector).length === 0) return;
  console.log('Initializing DatePicker for ' + selector);
  $(selector).datepicker({
    numberOfMonths: 1,
    dateFormat: 'dd-M-yy',
    prevText:
      '<svg class="svg-inline--fa fa-chevron-left fa-w-16 m-r-xs" aria-hidden="true" data-prefix="fa" data-icon="chevron-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"></path></svg>',
    nextText:
      '<svg class="svg-inline--fa fa-chevron-right fa-w-16 m-r-xs" aria-hidden="true" data-prefix="fa" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg>'
  });
};

window.TS.initDependsOn = function(){
  console.log("initializing DependsOn")
  
    dependsOn = function(triggerValue, target, targetValue, source) {
        var $source = source
        var $target = $(target)
            
            
            var pass = false;

            // Determine
            if ((triggerValue === null) || (typeof triggerValue === 'undefined')) {
                // We don't have a value
                if ($source.is(':checkbox,:radio')) {
                    pass = $source.is(':selected:enabled,:checked:enabled');
                }
                else {
                    pass = Boolean($source.val());
                }
            }
            else {
                // We do have a value
              console.log("we have a value")
                if ($source.is(":checkbox")) {
                    $source.filter(":checkbox:checked:enabled").each(function() {
                        if ($(this).val() != triggerValue) {
                            pass = true;
                            return false;
                        }
                    });
                } else if ($source.is(':radio')) {
                    pass = $source.filter(':radio:checked:enabled').val() != triggerValue;
                } else {
                  console.log(target)
                  console.log($target.val())
                  console.log($source.val())
                    //handles multi-value select inputs as well as single values
                    pass = $.inArray(triggerValue, [].concat($source.val())) == -1;
                    //pass = triggerValue == $source.val()
                    
                }
            }
           
            // console.log(dependsOnStatus);
            // Adjust
            if (!pass) {
                $target.attr('readonly', 'readonly').addClass('readonly');
                $target.val(targetValue).trigger('change');
            }
            else {
                $target.removeAttr('readonly').removeClass('readonly');
                $target.trigger('change');
                
            }
        };
    $('.dependsOn').on('rightnow change', function() {
      console.log("value changed");
      var fieldToChange = ($(this).attr('data-fieldToChange').toString());
      var valueTrigger = ($(this).attr('data-valueTrigger').toString());
      var valueToSet = ($(this).attr('data-valueToSet').toString());
      console.log($(this).val())

      if ($(this).is(':checked')){
        dependsOn(valueTrigger,fieldToChange,valueToSet, $(this))
      }
    }).trigger("rightnow")
    



}

window.TS.initHiddenConditionals = function(selector) {
    if (typeof selector === 'undefined') {
      selector = '.hiddenConditional';
    }
    if ($(selector).length === 0) return;
    console.log('Initializing HiddenCOnditionals for ' + selector);
    $('.hiddenConditional').click(function(e) {
      e.preventDefault(); 
      var cleanSelector = $(this).attr('data-datac').toString().replace(/(:|\.|\[|\]|,)/g, "\\$1");
      var listenTo = cleanSelector.substring(0, 1) == '#' ? cleanSelector : '[name=' + cleanSelector + ']';
      console.log(listenTo)
        var e = $(this).attr("data-datac").toString();
        var f = $(this).attr("data-condFunction").toString();
        var g = Number($(this).attr("data-condMax"));
        var startElement = $(listenTo);
        console.log(startElement.val())
        if (!startElement.val()){
          value = 0
        }else{
          value = parseInt(startElement.val());
        }
        if (f == "add"){
          if(value != g){
            startElement.attr('value', value + 1);
            startElement.val(value + 1).trigger("input");
          }
        }else{
          startElement.attr('value', value - 1);
          startElement.val(value - 1).trigger("input");
        }

        console.log(startElement.prev().prop('nodeName'));
        
        startElement.change();
        startElement.trigger( "click" );
        console.log(startElement.val())
          
    } );
  

}

window.TS.initDirty = function(selector){
/*!
 * jQuery Plugin: Are-You-Sure (Dirty Form Detection)
 * https://github.com/codedance/jquery.AreYouSure/
 *
 * Copyright (c) 2012-2014, Chris Dance and PaperCut Software http://www.papercut.com/
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * Author:  chris.dance@papercut.com
 * Version: 1.9.0
 * Date:    13th August 2014
 */
(function($) {
  
  $.fn.areYouSure = function(options) {
      
    var settings = $.extend(
      {
        'message' : 'You have unsaved changes!',
        'dirtyClass' : 'dirty',
        'change' : null,
        'silent' : false,
        'addRemoveFieldsMarksDirty' : false,
        'fieldEvents' : 'change keyup propertychange input',
        'fieldSelector': ":input:not(input[type=submit]):not(input[type=button])"
      }, options);

    var getValue = function($field) {
      if ($field.hasClass('ays-ignore')
          || $field.hasClass('aysIgnore')
          || $field.attr('data-ays-ignore')
          || $field.attr('name') === undefined) {
        return null;
      }

      if ($field.is(':disabled')) {
        return 'ays-disabled';
      }

      var val;
      var type = $field.attr('type');
      if ($field.is('select')) {
        type = 'select';
      }

      switch (type) {
        case 'checkbox':
        case 'radio':
          val = $field.is(':checked');
          break;
        case 'select':
          val = '';
          $field.find('option').each(function(o) {
            var $option = $(this);
            if ($option.is(':selected')) {
              val += $option.val();
            }
          });
          break;
        default:
          val = $field.val();
      }

      return val;
    };

    var storeOrigValue = function($field) {
      $field.data('ays-orig', getValue($field));
    };

    var checkForm = function(evt) {

      var isFieldDirty = function($field) {
        var origValue = $field.data('ays-orig');
        if (undefined === origValue) {
          return false;
        }
        return (getValue($field) != origValue);
      };

      var $form = ($(this).is('form')) 
                    ? $(this)
                    : $(this).parents('form');

      // Test on the target first as it's the most likely to be dirty
      if (isFieldDirty($(evt.target))) {
        setDirtyStatus($form, true);
        return;
      }

      $fields = $form.find(settings.fieldSelector);

      if (settings.addRemoveFieldsMarksDirty) {              
        // Check if field count has changed
        var origCount = $form.data("ays-orig-field-count");
        if (origCount != $fields.length) {
          setDirtyStatus($form, true);
          return;
        }
      }

      // Brute force - check each field
      var isDirty = false;
      $fields.each(function() {
        $field = $(this);
        if (isFieldDirty($field)) {
          isDirty = true;
          return false; // break
        }
      });
      
      setDirtyStatus($form, isDirty);
    };

    var initForm = function($form) {
      var fields = $form.find(settings.fieldSelector);
      $(fields).each(function() { storeOrigValue($(this)); });
      $(fields).unbind(settings.fieldEvents, checkForm);
      $(fields).bind(settings.fieldEvents, checkForm);
      $form.data("ays-orig-field-count", $(fields).length);
      setDirtyStatus($form, false);
    };

    var setDirtyStatus = function($form, isDirty) {
      var changed = isDirty != $form.hasClass(settings.dirtyClass);
      $form.toggleClass(settings.dirtyClass, isDirty);
        
      // Fire change event if required
      if (changed) {
        if (settings.change) settings.change.call($form, $form);

        if (isDirty) $form.trigger('dirty.areYouSure', [$form]);
        if (!isDirty) $form.trigger('clean.areYouSure', [$form]);
        $form.trigger('change.areYouSure', [$form]);
      }
    };

    var rescan = function() {
      var $form = $(this);
      var fields = $form.find(settings.fieldSelector);
      $(fields).each(function() {
        var $field = $(this);
        if (!$field.data('ays-orig')) {
          storeOrigValue($field);
          $field.bind(settings.fieldEvents, checkForm);
        }
      });
      // Check for changes while we're here
      $form.trigger('checkform.areYouSure');
    };

    var reinitialize = function() {
      initForm($(this));
    };

    var openConfirmation = function () {
      $dirtyForms = $("form").filter('.' + settings.dirtyClass);
      if ($dirtyForms.length == 0) {
        return;
      }
      // Prevent multiple prompts - seen on Chrome and IE
      if (navigator.userAgent.toLowerCase().match(/msie|chrome/)) {
        if (window.aysHasPrompted) {
          return;
        }
        window.aysHasPrompted = true;
        window.setTimeout(function() {window.aysHasPrompted = false;}, 900);
      }

      return true;
    };

    if (!settings.silent && !window.aysUnloadSet) {
      window.aysUnloadSet = true;

      $(window).bind('beforeunload', function() {
        if(openConfirmation()) {
          return settings.message;
        }
/*         var resourceName = $(selector).data('resource-name');
        var formCompleteStatus = $('input[name="' + resourceName + '[complete]"]').val()
        console.log("value of "+formCompleteStatus)
        console.log("nothing to submit")
        if (formCompleteStatus !== true){
          console.log("form not completed")
          return "Are you sure you wish to submit this form with incomplete data?"
        }else{
          console.log("form completed, no need for warning")
        } */
        
      });

      $(document).bind('turbolinks:before-visit', function() {
        if(openConfirmation()) {
          return confirm(settings.message);
        }
      });
    }

    return this.each(function(elem) {
      if (!$(this).is('form')) {
        return;
      }
      var $form = $(this);
        
      $form.submit(function() {
        $form.removeClass(settings.dirtyClass);
      });
      $form.bind('reset', function() { setDirtyStatus($form, false); });
      // Add a custom events
      $form.bind('rescan.areYouSure', rescan);
      $form.bind('reinitialize.areYouSure', reinitialize);
      $form.bind('checkform.areYouSure', checkForm);
      initForm($form);
    });
  };
})(jQuery);

  //stop unsaved forms being lost

  if (typeof selector === 'undefined') {
    selector = '.validateForm';
  }
  if ($(selector).length === 0) return;
  console.log('Initializing DirtySubmit3 for ' + selector);
  $(selector).areYouSure({'message':'This form has not been saved! Are you sure you want to leave this page?'});



}

// Can override using data-attributes -
window.TS.initSelect2 = function(selector) {
  if (typeof selector === 'undefined') {
    selector = '.smart-select2';
  }
  if ($(selector).not('.select2-hidden-accessible').length === 0) return;
  console.log('Initializing select2 for ' + selector);
  $(selector)
    .not('.select2-hidden-accessible')
    .select2({
      tags: true,
      createTag: function(params) {
        return {
          id: params.term,
          text: params.term,
          newOption: true
        };
      },
      templateSelection: function(data) {
        if (data.id === '') {
          // adjust for custom placeholder values
          var placeholder = $(this.context).data('placeholder');
          if (placeholder !== undefined) {
            return placeholder;
          }
        }
        return data.text;
      },
      templateResult: function(data) {
        var $result = $('<span></span>').text(data.text);
        if (data.newOption) {
          $result.append(' <em>(other)</em>');
        }
        return $result;
      }
    });
  $(selector).on('change', function() {
    if ($(this).length === 0) return;
    if ($(this).is(':hidden')) return;
    $(this).valid();
    $('.select2-selection__choice[title*="Please select"]').remove();
  });
  $('.select2-selection--single').addClass('gui-input');
};

window.TS.initTimeMasking = function() {
  if (typeof selector === 'undefined') {
    selector = '.time_masking';
  }
  if ($(selector).length === 0) return;
  console.log('Initializing TimeMasker for ' + selector);

    $('.time_masking').toArray().forEach(function(field){
      new Cleave(field, {
        time: true,
        timePattern: ['h', 'm']
      })
    })
};

// Expects .checkCompletion on a form object
window.TS.checkCompletion = function(selector) {
  if ($('[name=commit]').length == 0) return;
  if (typeof selector === 'undefined') {
    selector = '.checkCompletion';
  }
  if ($(selector).length == 0) return;
  console.log('Initializing checkCompletion for ' + selector);
};

window.TS.checkCompleted = function(selector) {
  console.log('Running checkCompletion for ' + selector);
  var resourceName = $(selector).data('resource-name');
  if (resourceName === undefined) {
    console.log('data-resource-name is required with .checkCompletion');
  }
  var completionColletor = 0
  $('input:text[data-complete]:visible, select[data-complete]:visible').each(function() {
    var name = $(this).attr('name');
    //console.log("checking " + name)
    if ($(this).val() == '') {
      $('input[name="' + resourceName + '[complete]"]').val(false);
      completionColletor += 1
      //console.log('setting value of complete field to '+$('input[name="' + resourceName + '[complete]"]').val())
      //console.log(name + ' is incomplete. Onto next')
      return;
    }
  });
  $('input:radio[data-complete]:visible').each(function() {
    var name = $(this).attr('name');
    var radio = $("input:radio[name='" + name + "']:checked");
    if (radio.length === 0) {
      completionColletor += 1
      $('input[name="' + resourceName + '[complete]"]').val(false);
      return;
    }
  });
  $('input:checkbox[data-complete]:visible').each(function() {
    var name = $(this).attr('name');
    var checkbox = $("input:checkbox[name='" + name + "']:checked");
    if (checkbox.length === 0) {
      completionColletor += 1
      $('input[name="' + resourceName + '[complete]"]').val(false);
      return;
    }
  });
  //console.log("current status of complete field is "+$('input[name="' + resourceName + '[complete]"]').val())
  //console.log("number of incomplete fields = "+completionColletor)
  if (completionColletor < 1){
    $('input[name="' + resourceName + '[complete]"]').val(true);
  }else{
    $('input[name="' + resourceName + '[complete]"]').val(false)
  }
};

// Expects .resetRadioButton on a form object
window.TS.resetRadioButton = function(selector) {
  if (typeof selector === 'undefined') {
    selector = '.resetRadioButton';
  }
  if ($(selector).length === 0) return;
  if (window.TS[selector + 'inputRadioButton_initialized'] !== undefined) return;
  console.log('Initializing resetRadioButton for ' + selector);
  $(document).on('click', 'form' + selector + ' input:radio', function(e) {
    console.log('radio reset click on' + selector);
    var $inp = $(this); //cache the selector
    if ($inp.is('.previousSelect')) {
      //see if it has the selected class
      console.log('radio reset already selected');
      $inp.prop('checked', false);
      $inp.removeClass('previousSelect');
      $inp.trigger('change');
      return;
    }
    $("input:radio[name='" + $inp.prop('name') + "'].previousSelect").removeClass('previousSelect');
    $inp.addClass('previousSelect');
  });
  window.TS[selector + 'inputRadioButton_initialized'] = true;
};

//
// Page Specific Code
//

// This disables the All sites options if the user selected is not an admin or
// super admin
// selector is form object - #edit_user_form or #new_user
window.TS.disableAllSitesOptIfNoPermissions = function(selector) {
  window.TS.checkPermissions_and_disableAllSites(selector); // Check on page load
  if (TS[selector + 'disableAllSitesIfNoPermissions_initialized'] !== undefined) return;
  $(document).on('change', selector + ' select[name="user[role]"]', function() {
    window.TS.checkPermissions_and_disableAllSites(selector);
  });
  window.TS[selector + 'disableAllSitesIfNoPermissions_initialized'] = true;
};

window.TS.checkPermissions_and_disableAllSites = function(selector) {
  val = $(selector + ' select[name="user[role]"]').val();
  if (val === 'read_all' || val === 'admin' || val === 'super_admin') {
    $('select[name="user[site_number]"] > option[value="0"]').attr('disabled', false);
  } else {
    $('select[name="user[site_number]"] > option[value="0"]').attr('disabled', 'disabled');
  }
  window.TS.initSelect2('select[name="user[site_number]"]');
};

window.TS.updateSalmsIdOnSiteChange = function(selector) {
  if (typeof selector === 'undefined') {
    selector = ".updateSalmsIdOnSiteChange [name='subject[site_number]']";
  }
  if ($(selector).length === 0) return;
  if (window.TS.salmsIdCleaveinit !== undefined) {
    console.log('Re-initializing SalmsId masker');
    window.TS.setupSalmsIdOnSiteChange(selector);
  } else {
    console.log('Initializing SalmsId masker');
    $(document).on('change', selector, function() {
      window.TS.setupSalmsIdOnSiteChange(this);
    });
    $(selector).trigger('change');
    window.TS['salmsIdCleaveinit'] = true;
  }
};

window.TS.setupSalmsIdOnSiteChange = function(obj) {
  var site_number = $(obj).val();
  var subjectIdPrefix = 'CRO' + '-' + window.TS.pad_with_zeroes(site_number, 2) + '-';
  if (window.TS.salmsIdCleave !== null && window.TS.salmsIdCleave !== undefined) {
    window.TS.salmsIdCleave.destroy();
  }
  var current_val = $("[name='subject[subject_id]']").val();
  if (current_val.length > 7) {
    $("[name='subject[subject_id]']").val(subjectIdPrefix + current_val.slice(7));
  } else {
    $("[name='subject[subject_id]']").val('');
  }
  window.TS.salmsIdCleave = new Cleave("[name='subject[subject_id]']", {
    prefix: subjectIdPrefix,
    delimiter: '',
    blocks: [7, 4],
    uppercase: true
  });
  window.TS.salmsIdCleave.setRawValue(current_val);
};

window.TS.pad_with_zeroes = function(string, len) {
  var zeroes = '0'.repeat(len);
  return zeroes.substring(string.length, len) + string;
};


window.TS.sum_fields = function() {

  $(document).ready(function() {
    console.log("sum_fields running")
    $.fn.isBefore= function(sel){
        return this.nextAll().filter(sel).length !== 0;
    };

    $('*[data-warning=true]').blur(
      function(event) {
        warning_target = $(this)
        $.fn.warning_validator = function(valueIs, valueShould, operator) {
          if (valueIs == ''){
            return true
          }
          if (valueShould === true) {
            valueShould = 'true';
          } else if (valueShould === false) {
            valueShould = 'false';
          }
          switch (operator) {
            case '==':
              return valueIs == valueShould;
              break;
            case '!=':
              return valueIs != valueShould;
            case '<=':
              return parseInt(valueIs) <= parseInt(valueShould);
            case '<':
              return parseInt(valueIs) < parseInt(valueShould);
            case '>=':
              return parseInt(valueIs) >= parseInt(valueShould);
            case '>':
              return parseInt(valueIs) > parseInt(valueShould);
            case 'in':
              valueShouldArray = valueShould.split(',');
              //console.log("in evaluation: ")
              //console.log("value wanted: "+valueShould)
              //console.log("value selected: "+valueIs)
              for (let i = 0; i < valueShouldArray.length; i++) {
                valueShouldArray[i] = valueShouldArray[i].replace(/{COMMA}/g, ',');
              }
              return valueIs !== '' && valueShould !== '' && $.inArray(valueIs, valueShouldArray) !== -1;
            case 'radioIn':
              valueShouldArray = valueShould.split(',');
              for (let i = 0; i < valueShouldArray.length; i++) {
                valueShouldArray[i] = valueShouldArray[i].replace(/{COMMA}/g, ',');
              }
              return valueIs !== '' && valueShould !== '' && $.inArray(valueIs, valueShouldArray) !== -1;
            case 'multiple':
              if (valueIs !== null) {
                return valueIs !== '' && $.inArray(valueShould, valueIs) !== -1;
              }
              case 'multipleSelect2':
                if (valueIs !== null) {
                  return valueIs !== '' && $.inArray(valueShould, valueIs) !== -1;
                }
                case 'multipleNotSelect2':
                  if (valueIs !== null) {
                    return valueIs !== '' && $.inArray(valueShould, valueIs) == -1;
                  }
                  case 'multipleIn':
                    if (valueIs !== null) {
                      return valueIs !== '' && $.fn.containsAny(valueIs, valueShould);
                    }
          }
        }
        if (($.fn.warning_validator($(this).val(), $(this).data("warning-should"), $(this).data("warning-operator")))===false) {
          $(this).css("background-color", "Orange");
          if ($(this).isBefore($(".warning")) === false){
            $(this).after("<div class='warning' style='color:red;margin-bottom: 20px;'>"+$(this).data("warning-message")+"</div>");
          }
        } else {
          $(this).next(".warning").remove();
          $(this).css("background-color", "inherit");
        }
      }
    );
    
    
    $('*[data-addition=true]').change(
      function(event){
        var sum = 0;
        if ($(this).attr('type') == 'radio' || $(this).attr('type') == 'checkbox') {
          $("*[data-addition=true]:checked").each(function(){
            if ($(this).val() !='99'){
              sum += +$(this).val();
            }
          });
        }else{
          $("*[data-addition=true]").each(function(){
            if ($(this).val() !='99'){
              sum += +$(this).val();
            }
          })
        };
        console.log(sum)
        $($(this).data("addition-total")).val(sum);
        //$($(this).data("addition-total")).valid();
      }
    );
  });
};
